import React from "react";

const DATAMARTS = [
  {
    name: "Telemetry",
    desc: "Live and historical sensor readings from vessel equipments",
    color: "#1a9e78",
  },
  {
    name: "Pending Jobs",
    desc: "Pending and overdue planned maintenance system job orders",
    color: "#ba7517",
  },
  {
    name: "Main Engine Monthly Performance Report",
    desc: "Contains all the Main Engine Monthly performance parameters",
    color: "#185fa5",
  },
  {
    name: "Running Hours",
    desc: "Equipment running hour counter readings",
    color: "#534ab7",
  },
  {
    name: "Scavenge Drain Oil",
    desc: "Scavenge drain oil analysis — BN, Fe content, feed rates per cylinder",
    color: "#993556",
  },
  {
    name: "Cylinder Oil Consumption",
    desc: "Lubricator feed rates and consumption logs per cylinder unit",
    color: "#0f6e56",
  },
  {
    name: "Fuel Oil Analysis",
    desc: "Bunker sample lab results, viscosity, sulphur and contamination data",
    color: "#854f0b",
  },
];

const initials = (name) =>
  name.split(" ").slice(0, 2).map(w => w[0]).join("").toUpperCase();

const DatamartItem = ({ name, desc, color }) => (
  <div
    style={{
      display: "flex", alignItems: "flex-start", gap: 10,
      padding: "11px 14px", borderBottom: "0.5px solid #e2e4e8",
      cursor: "pointer", transition: "background .12s",
    }}
    onMouseEnter={e => e.currentTarget.style.background = "#fafbfc"}
    onMouseLeave={e => e.currentTarget.style.background = "transparent"}
  >
    <div style={{
      width: 32, height: 32, borderRadius: 8, flexShrink: 0,
      background: color + "18", display: "flex", alignItems: "center",
      justifyContent: "center", fontSize: 10, fontWeight: 600, color, marginTop: 1,
    }}>
      {initials(name)}
    </div>
    <div style={{ minWidth: 0 }}>
      <div style={{ fontSize: 12.5, fontWeight: 500, color: "#1a1e2e", lineHeight: 1.3 }}>{name}</div>
      <div style={{ fontSize: 11, color: "#8a909e", marginTop: 3, lineHeight: 1.5 }}>{desc}</div>
    </div>
  </div>
);

const AvailableDatamarts = () => (
  <div style={{
    background: "#fff", border: "0.5px solid #e2e4e8",
    borderRadius: 10, overflow: "hidden",
  }}>
    {/* Header */}
    <div style={{
      display: "flex", alignItems: "center", gap: 8,
      padding: "12px 14px", borderBottom: "0.5px solid #e2e4e8",
      background: "#f5f6f8",
    }}>
      <div style={{
        width: 22, height: 22, borderRadius: 6, background: "#e1f5ee",
        display: "flex", alignItems: "center", justifyContent: "center",
      }}>
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#0f6e56" strokeWidth="2.5">
          <ellipse cx="12" cy="5" rx="9" ry="3"/>
          <path d="M21 12c0 1.66-4.03 3-9 3S3 13.66 3 12"/>
          <path d="M3 5v14c0 1.66 4.03 3 9 3s9-1.34 9-3V5"/>
        </svg>
      </div>
      <span style={{ fontSize: 13, fontWeight: 500, color: "#1a1e2e" }}>Available Datamarts</span>
    </div>

    {/* List */}
    <div>
      {DATAMARTS.map((d, i) => (
        <DatamartItem key={i} {...d} />
      ))}
    </div>
  </div>
);

export default AvailableDatamarts;